import { effect, inject, Injectable, signal } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ArrowAliasV2 } from '../../interfaces/arrow-alias.interface';
import { AppStateService } from '../app-state/app-state.service';
import { ConnectionService } from '../connection/connection.service';
import { isNonNullable } from '../../helpers/general.helper'
import { toObservable } from '@angular/core/rxjs-interop'

@Injectable({
  providedIn: 'root',
})
export class ArrowAliasService {
  private readonly connectionService = inject(ConnectionService);

  readonly #appState = inject(AppStateService);

  readonly #aliasV2List = signal<ArrowAliasV2[]>([]);
  public aliasV2List = this.#aliasV2List.asReadonly();
  public aliasV2List$ = toObservable(this.#aliasV2List);

  constructor() {
    effect(() => {
      const projectId = this.#appState.projectId();
      if (projectId > 0) {
        console.log('ArrowAliasService: projectId effect', this.#appState.projectId());
        this.getV2(this.#appState.projectId()).subscribe();
      }
    });
  }

  /** Convert Connection to ArrowAliasV2 for backward compatibility */
  private connection2ArrowAliasV2(connection: any): ArrowAliasV2 | undefined {
    if (connection.type !== 'DataFusion' || !connection.connectionId) {
      return undefined;
    }

    // Map Connection to ArrowAliasV2 structure
    return {
      aliasId: connection.connectionId,
      projectId: connection.projectId,
      name: connection.name,
      url: connection.config?.url || '',
      cloudConfig: connection.config || {},
      cloudConfigSecret: connection.config?.passwordSecretId || null,
      passwordSecretId: connection.config?.passwordSecretId || null
    };
  }

  getV2(projectId: number = this.#appState.projectId()): Observable<ArrowAliasV2[]> {
    // Use new ConnectionService to get DataFusion connections (replaces old arrow endpoint)
    return this.connectionService.getConnections(projectId).pipe(
      map((connections) => {
        console.log('ArrowAliasService getV2 (from connections):', connections);

        // Filter for DataFusion connections (Arrow type)
        const arrowConnections = connections.filter(conn => conn.type === 'DataFusion');

        // Convert Connections to ArrowAliasV2 format for backward compatibility
        const v2list = arrowConnections.map(conn => this.connection2ArrowAliasV2(conn)).filter(isNonNullable) as ArrowAliasV2[];
        this.#aliasV2List.set(v2list);
        return v2list;
      })
    );
  }
}
